/* eslint-disable */
export default {
  today: 'Today',
  yesterday: 'Yesterday',
  empty: 'No call records',
} as const;

// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"yesterday"@#@ @source: @#@"Yesterday"@#@
// @key: @#@"empty"@#@ @source: @#@"No call records"@#@
